export default "__VITE_ASSET__100d1667__"